import ProposalDetailsPage from './ProposalDetailsPage';

export default ProposalDetailsPage;